import { type ColorValue, processColor } from 'react-native';

// this allows you to pass in a color, either via its CSS name (i.e. "red", "blue", etc.) or a 6-digit hex value,
// along with an alpha value between 0-1, and returns a CSS rgba value
export const getRGBA = (color: number | ColorValue, alpha: number = 1) => {
    const processedColor = processColor(color);
    if (processedColor == null) return 'rgba(255, 255, 255, 1)';

    const colorInt = Number(processedColor);

    const r = (colorInt >> 16) & 255;
    const g = (colorInt >> 8) & 255;
    const b = colorInt & 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
